import React from 'react';
import TradingViewWidget from './Chart';

interface ChartContentProps {
  symbol: string;
  interval?: string;
  timezone?: string;
  theme?: string;
  range?: string;
  compared_symbols: string[];
  studies?: string[];
  action: string;
  chartKey?: string;
  style?: string;
  volumeVisible?: boolean;
}

const MemoizedTradingViewWidget = React.memo(TradingViewWidget);

const ChartContent: React.FC<ChartContentProps> = ({
  symbol,
  interval ,
  timezone ,
  theme ,
  range ,
  compared_symbols = [],
  studies = [],
  action,
  chartKey,
  style,
  volumeVisible
}) => {
  return (
    <MemoizedTradingViewWidget
      chartKey={chartKey}
      symbol={symbol}
      interval={interval}
      timezone={timezone}
      theme={theme}
      range={range}
      compared_symbols={compared_symbols}
      studies={studies}
      action={action}
      style={style}
      volumeVisible={volumeVisible}
    />
  );
};

export default React.memo(ChartContent);
